var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-limited-subscription-sidebar"},[_c('select-input',{staticClass:"mt-0",attrs:{"setup":{
      'func': _vm.setTarget,
      'args': {
        'model': _vm.node.data,
        'key': 'target',
        'options': _vm.targets,
        'clearable': false,
        'prefix': 'check_limited_subscription_',
      }
    }}}),_c('time-unit-input',{attrs:{"setup":{
      'func': _vm.setOffset,
      'args': {
        'model': _vm.node.data,
        'key': 'offset',
        'prefix': 'check_limited_subscription_',
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }